<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    Header(:content="headerContent")
    DrawerMenu(v-if="uid" :uid="uid" :show="showGlobalMenu" @close="toggleMenu")
    div.wrap-license
      ModuleLicense(v-if="license" :license="license")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-license {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header.vue'
import DrawerMenu from '@/components/shared/DrawerMenu'
import ModuleLicense from '@/components/module/ModuleLicense'

export default {
  components: {
    Auth, Header, DrawerMenu, ModuleLicense
  },
  data () {
    return {
      headerContent: {
        title: 'ライセンス',
        left: {
          icon: 'mdi-menu',
          action: this.toggleMenu 
        }
      },
      showGlobalMenu: false,
      user: null,
      license: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async onLoggedIn () {
      this.user = await database.userCollection().findById(this.uid)
      if (!this.user.paymentIsActive) {
        this.$router.push('/payment')
        return
      }

      this.license = await database.licenseCollection().findById(this.user.license)
    },
    toggleMenu () {
      this.showGlobalMenu = !this.showGlobalMenu
    }
  }
}
</script>
